import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MemberMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allMemberMasterList: any[]; 

}

const initialState: MemberMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allMemberMasterList: [], 
};

export const memberMasterSlice = createSlice({
  name: 'memberMaster',
  initialState,
  reducers: {
    setMemberMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setMemberMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setMemberMasterList: (state, action) => {
      state.allMemberMasterList = action.payload.data; // no pagination
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMemberMaster,setMemberMasterBySearch, setMemberMasterList ,reset } = memberMasterSlice.actions;
export const getMemberMasterDetails = (state: RootState) => state.memberMaster.data;
export const getMemberMasterBySearchDetails= (state: RootState) => state.memberMaster.data;
export const getMemberMasterTotalRecords=(state:RootState)=>state.memberMaster.totalRecords;
export const getMemberMasterList = (state: RootState) => state.memberMaster.allMemberMasterList;
export default memberMasterSlice.reducer;